import * as React from 'react';

export const usePageVisible = (): boolean => {
  const [visible, setVisible] = React.useState<boolean>(true);

  React.useEffect(() => {
    const handleVisible = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', handleVisible);
    return () => {
      document.removeEventListener('visibilitychange', handleVisible);
    };
  }, []);

  return visible;
};
